export default "__VITE_ASSET__BD3PH9tr__"